import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["aria-expanded"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CoveoAiIcon = _resolveComponent("CoveoAiIcon");
  const _component_CloseIcon = _resolveComponent("CloseIcon");
  return $props.displayIcon ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($options.rootClass),
    onMouseleave: _cache[5] || (_cache[5] = $event => $options.isLoggedIn && !$props.isFirstView ? $options.handleCollapse() : null),
    onFocusout: _cache[6] || (_cache[6] = $event => $options.isLoggedIn ? $options.handleFocusOut($event) : null)
  }, [_createElementVNode("button", {
    class: _normalizeClass([`${$options.rootClass}__trigger`, $options.isLoggedIn && $options.isExpanded ? `${$options.rootClass}__trigger--active` : '']),
    onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.handleExpand && $options.handleExpand(...args)),
    onClick: _cache[1] || (_cache[1] = $event => $options.isLoggedIn ? null : $options.handleExpand),
    onKeydown: [_cache[2] || (_cache[2] = _withKeys(_withModifiers($event => $options.isLoggedIn ? $options.handleExpand() : null, ["prevent"]), ["enter"])), _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => $options.isLoggedIn ? $options.handleExpand() : null, ["prevent"]), ["space"]))],
    "aria-expanded": $options.isExpanded,
    "aria-haspopup": "dialog",
    "aria-label": 'Coveo AI Information',
    tabindex: 0
  }, [_renderSlot(_ctx.$slots, "trigger-content", {}, () => [_createElementVNode("span", {
    class: _normalizeClass(`${$options.rootClass}__icon`)
  }, [_createVNode(_component_CoveoAiIcon)], 2)])], 42, _hoisted_1), _createVNode(_Transition, {
    name: "coveo-panel"
  }, {
    default: _withCtx(() => [$options.isExpanded ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(`${$options.rootClass}__panel`),
      onMouseenter: _cache[4] || (_cache[4] = $event => $options.isLoggedIn ? $options.handleExpand() : null)
    }, [_createElementVNode("div", {
      class: _normalizeClass(`${$options.rootClass}__panel-header`)
    }, [_createElementVNode("p", {
      class: _normalizeClass(`${$options.rootClass}__panel-title`)
    }, [_renderSlot(_ctx.$slots, "panel-title")], 2), _createElementVNode("div", {
      class: _normalizeClass(`${$options.rootClass}__panel-actions`)
    }, [_createElementVNode("span", {
      class: _normalizeClass(`${$options.rootClass}__panel-coveo-icon`)
    }, [_createVNode(_component_CoveoAiIcon)], 2), _createElementVNode("span", {
      class: _normalizeClass(`${$options.rootClass}__close`)
    }, [_createVNode(_component_CloseIcon, {
      onClick: $options.handleCollapse,
      onKeydown: [_withKeys(_withModifiers($options.handleCollapse, ["prevent"]), ["enter"]), _withKeys(_withModifiers($options.handleCollapse, ["prevent"]), ["space"])],
      tabindex: "0",
      role: "button",
      "aria-label": 'Close'
    }, null, 8, ["onClick", "onKeydown"])], 2)], 2)], 2), _createElementVNode("div", {
      class: _normalizeClass(`${$options.rootClass}__panel-content`)
    }, [_renderSlot(_ctx.$slots, "panel-content")], 2)], 34)) : _createCommentVNode("", true)]),
    _: 3
  })], 34)) : _createCommentVNode("", true);
}